import { ShapeTool } from ".";
import { Vector2 } from "../utils/vector2";

const fabric = require("../fabric").fabric;

export class RectangleTool extends ShapeTool {

  mesurementTexts = {
    width: null,
    height: null,
    area: null,
  };

  measurementActive = false;

  buildShape(pointer, origX, origY) {
    let styleModule = this.imageEditor.getModule("style");

    this.measurementActive = false;
    if(this.imageEditor.isToolbarToggleActive("mesures-toggle")) {
      this.measurementActive = true;

      this.mesurementTexts.width = this.getNewMesurementText(origX, origY);
      this.mesurementTexts.width.text = ``;
      
      this.mesurementTexts.height = this.getNewMesurementText(origX, origY);
      this.mesurementTexts.height.text = ``;
      
      this.mesurementTexts.area = this.getNewMesurementText(origX, origY);
      this.mesurementTexts.area.text = ``;

      this.imageEditor.canvas.add(this.mesurementTexts.width);
      this.imageEditor.canvas.add(this.mesurementTexts.height);
      this.imageEditor.canvas.add(this.mesurementTexts.area);
    }

    return new fabric.Rect({
      left: origX,
      top: origY,
      originX: 'left',
      originY: 'top',
      width: pointer.x - origX,
      height: pointer.y - origY,
      angle: 0,
      fill: "rgba(0,0,0,0)",
      stroke: styleModule.fillColor,
      strokeWidth: styleModule.strokeSize,
      transparentCorners: false,
      selectable: false
    });
  }

  mouseDrag(rect, pointer, origX, origY) {

    if(origX > pointer.x){
      rect.set({ left: Math.abs(pointer.x) });
    }
    if(origY > pointer.y){
      rect.set({ top: Math.abs(pointer.y) });
    }
    rect.set({ width: Math.abs(origX - pointer.x) });
    rect.set({ height: Math.abs(origY - pointer.y) });

    if(this.measurementActive) {
      this.drawWidthMesurement(rect.left, rect.top, rect.width, rect.strokeWidth * 5);
      this.drawHeightMesurement(rect.left, rect.top, rect.height, rect.strokeWidth * 5);
      this.drawAreaMesurement(rect.left, rect.top, rect.width, rect.height, rect.strokeWidth * 5);
    }
  }

  drawWidthMesurement(left, top, width, fontSize) {
    var textObj = this.mesurementTexts.width;

    var from = new Vector2(left, top);
    var topright = new Vector2(left + width, top)
    var middle = from.middle(topright);
    middle.x -= textObj.width / 2;
    
    var distance = this.imageEditor.calculateMesurementValue(width);
    distance = Math.round(distance * 100) / 100;

    textObj.text = `${distance}${this.imageEditor.mesurementUnit}`;
    textObj.fontSize = fontSize;
    textObj.left = middle.x;
    textObj.top = top - textObj.height;
    textObj.drawObject(this.imageEditor.canvas.getContext());
  }

  drawHeightMesurement(left, top, height, fontSize) {
    var textObj = this.mesurementTexts.height;

    var from = new Vector2(left, top);
    var topright = new Vector2(left, top + height)
    var middle = from.middle(topright);
    middle.y -= textObj.height / 2;
    
    var distance = this.imageEditor.calculateMesurementValue(height);
    distance = Math.round(distance * 100) / 100;

    textObj.text = `${distance}${this.imageEditor.mesurementUnit}`;
    textObj.fontSize = fontSize;
    textObj.left = left - textObj.width - 10;
    textObj.top = middle.y;
    textObj.drawObject(this.imageEditor.canvas.getContext());
  }

  drawAreaMesurement(left, top, width, height, fontSize) {
    var textObj = this.mesurementTexts.area;

    var from = new Vector2(left, top);
    var topright = new Vector2(left, top + height)
    var middle = from.middle(topright);
    middle.y -= textObj.height / 2;
    
    var w = this.imageEditor.calculateMesurementValue(width);
    w = Math.round(w * 100) / 100;

    var h = this.imageEditor.calculateMesurementValue(height);
    h = Math.round(h * 100) / 100;

    var area = Math.round(w * h * 100) / 100;

    textObj.text = `${area}${this.imageEditor.mesurementUnit}²`;
    textObj.fontSize = fontSize;
    textObj.left = left + width / 2 - textObj.width / 2;
    textObj.top = top + height / 2 - textObj.height / 2;
    textObj.drawObject(this.imageEditor.canvas.getContext());
  }

}